<template lang="pug">
  header.page-header(:class="headerClass")
    .container.h-100
      .row.align-items-center.h-100
        .d-flex.flex-row.justify-content-center.w-100
          router-link.header-step(v-bind:class="{'header-step--active': step === 1}" :to="{ name: 'checkout' }")
            span.header-step__number 1
            h3.header-step__title {{ trans('labels.frontend.cart.steps.shipping-details') }}
          .header-step(v-bind:class="{'header-step--active': step === 2}" )
            span.header-step__number 2
            h3.header-step__title {{ trans('labels.frontend.cart.steps.payment') }}
          .header-step(v-bind:class="{'header-step--active': step === 3}")
            span.header-step__number 3
            h3.header-step__title {{ trans('labels.frontend.cart.steps.completed') }}
    img.page-header__background(:src='headerBackground', alt='')
</template>

<script>
export default {
  props: {
    step: {
      type: Number,
      required: true,
    },
    headerClass: {
      type: String,
      default: '',
    },
    headerBackground: {
      type: String,
      required: true,
    },
  },
};
</script>
